import { Link } from "react-router-dom";
import { useFavorites } from "@/hooks/useFavorites";

type Props = { open: boolean; onClose: () => void };

export default function FavoritesDrawer({ open, onClose }: Props) {
  const { favoriteMovies, remove, clear } = useFavorites();

  return (
    <div className={`fixed inset-0 z-[55] ${open ? "" : "pointer-events-none"}`} aria-hidden={!open}>
      <button
        type="button"
        aria-label="关闭收藏夹"
        onClick={onClose}
        className={`absolute inset-0 cursor-pointer bg-background-50/80 backdrop-blur-sm transition-opacity duration-300 ${
          open ? "opacity-100" : "opacity-0"
        }`}
      />
      <aside
        className={`absolute right-0 top-0 flex h-full w-full max-w-[400px] flex-col border-l border-background-300/70 bg-background-100 transition-transform duration-300 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between border-b border-background-300/60 px-5 py-4">
          <div>
            <p className="text-[10px] tracking-widest2 text-accent-400 font-label">MY ARCHIVE</p>
            <h2 className="font-heading text-base font-semibold text-foreground-50">我的收藏</h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-300/70 text-foreground-300 transition-colors hover:border-accent-500 hover:text-accent-400"
          >
            <i className="ri-close-line" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-4">
          {favoriteMovies.length === 0 ? (
            <div className="flex h-full flex-col items-center justify-center text-center">
              <i className="ri-heart-3-line text-3xl text-foreground-600" />
              <p className="mt-3 text-[13px] text-foreground-400">收藏夹还是空的</p>
              <p className="mt-1 text-[12px] leading-relaxed text-foreground-600">
                在影片卡片或详情页点击心形按钮，
                <br />
                就会保存在这台设备的浏览器里。
              </p>
            </div>
          ) : (
            <ul className="flex flex-col gap-3">
              {favoriteMovies.map((movie) => (
                <li key={movie.id} className="flex gap-3 rounded-lg border border-background-300/50 bg-background-50/60 p-2">
                  <Link
                    to={`/detail/${movie.id}`}
                    onClick={onClose}
                    className="block h-[74px] w-[52px] shrink-0 cursor-pointer overflow-hidden rounded"
                  >
                    <img
                      src={movie.poster}
                      alt={`${movie.title} 封面`}
                      className="h-full w-full object-cover object-top"
                    />
                  </Link>
                  <div className="min-w-0 flex-1">
                    <Link
                      to={`/detail/${movie.id}`}
                      onClick={onClose}
                      className="block cursor-pointer font-heading text-[13px] font-medium text-foreground-100 transition-colors hover:text-accent-400"
                    >
                      {movie.title}
                    </Link>
                    <p className="mt-1 text-[11px] text-foreground-500 font-label">
                      {movie.year} · {movie.region}
                    </p>
                    <button
                      type="button"
                      onClick={() => remove(movie.id)}
                      className="mt-1 flex cursor-pointer items-center gap-1 text-[11px] text-foreground-500 transition-colors hover:text-primary-400 font-label"
                    >
                      <i className="ri-delete-bin-line" />
                      移除
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {favoriteMovies.length > 0 && (
          <div className="border-t border-background-300/60 px-5 py-4">
            <button
              type="button"
              onClick={clear}
              className="w-full cursor-pointer rounded-md border border-background-300/70 py-2 text-[12px] text-foreground-300 transition-colors hover:border-primary-500 hover:text-primary-300 font-label"
            >
              清空收藏
            </button>
          </div>
        )}
      </aside>
    </div>
  );
}